// Spanish labels for the Applicants module's stored status codes. The codes
// themselves are English (backend convention); everything the aspirante o el
// gestor ve en pantalla se traduce aquí, de modo que ningún Chip muestre el
// código crudo.
import { APPLICANT_DOC_STATUS } from "../../constants";

// documentationStatus consolidado del aspirante / de la postulación.
export const ESTADO_DOC_LABELS = {
  [APPLICANT_DOC_STATUS.PENDING]: "Pendiente",
  [APPLICANT_DOC_STATUS.INCOMPLETE]: "Incompleta",
  [APPLICANT_DOC_STATUS.COMPLETE]: "Completa",
  [APPLICANT_DOC_STATUS.VALIDATED]: "Validada",
};

// Estado de un archivo cargado (y del rollup por tipo de documento).
export const DOC_FILE_STATUS_LABELS = {
  PENDING: "Pendiente",
  UPLOADED: "Cargado",
  VALIDATED: "Validado",
  REJECTED: "Rechazado",
  VENCIDO: "Vencido",
};

// Estado de la postulación del aspirante a una convocatoria. INTERNO: sólo para
// las vistas del gestor (listado y ficha del aspirante).
export const APPLICATION_STATUS_LABELS = {
  APPLIED: "Postulado",
  SELECTED: "Seleccionado",
  DOCS_STAGE2_PENDING: "Documentos etapa 2 pendientes",
  REJECTED: "No seleccionado",
};

// Los mismos estados, como se le muestran AL ASPIRANTE en las páginas públicas.
// La selección es una decisión interna que no se le comunica: lo que ve es que
// se le solicitaron documentos adicionales. Todo lo no mapeado cae en las
// etiquetas internas de arriba.
export const APPLICANT_FACING_STATUS_LABELS = {
  ...APPLICATION_STATUS_LABELS,
  SELECTED: "Documentos adicionales solicitados",
  DOCS_STAGE2_PENDING: "Documentos adicionales solicitados",
};

// Abreviaturas para el tipo de documento (config.idTypes guarda el texto largo).
// Solo para vistas compactas como la columna "Documento" de la lista; los tipos
// no mapeados se muestran tal cual.
export const ID_TYPE_SHORT = {
  "Cédula de ciudadanía": "C.C.",
  "Cédula de extranjería": "C.E.",
  "Tarjeta de identidad": "T.I.",
  "Pasaporte": "Pasaporte",
};

// Traduce un código, dejándolo tal cual si no está mapeado (nunca oculta datos).
export const labelForStatus = (map, code, fallback = "—") =>
  map[code] || code || fallback;
